import {
  isSignInWithEmailLink,
  signInWithEmailLink,
  type UserCredential,
} from 'firebase/auth'

import { getAuthInstance } from './runtime'
import { useAuthMutation, type UseAuthMutationResult } from './useAuthMutation'

interface MutationVariables {
  email: string | null
  emailLink: string | null
}

const useSignInWithEmailLinkMutation = (): UseAuthMutationResult<
  UserCredential,
  MutationVariables
> => {
  const auth = getAuthInstance()

  return useAuthMutation({
    mutationFn: async ({ email, emailLink }: MutationVariables) => {
      if (!email) {
        throw new Error('missing email')
      }

      if (!emailLink) {
        throw new Error('missing email link')
      }

      if (!isSignInWithEmailLink(auth, emailLink)) {
        throw new Error('invalid email link')
      }

      return signInWithEmailLink(auth, email, emailLink)
    },
  })
}

export default useSignInWithEmailLinkMutation
